module.exports = __webpack_public_path__ + "img/animal_hero.56232980.png";